export default __webpack_public_path__ + "static/media/parent.85799ba3.png";